<template>
  <div class="sqDetail">
    <div class="details" v-for="(item, index) in columns" :key="index">
      <span class="detailsLabel">{{ item.label }}:</span>
      <span>{{
        item.prop === "state"
          ? stateData(form[item.prop])
          : item.prop === "eventType"
          ? eventTypeData(form[item.prop])
          : form[item.prop]
      }}</span>
    </div>
    <div class="imginfo">
      <div class="detailsLabel" v-if="formSource.img.length > 0">图片：</div>
      <div class="source_item" v-if="formSource.img.length > 0">
        <img
          v-for="(item, index) in formSource.img"
          :key="index"
          :src="fileIdSrc(item)"
          @click="clickImg(item)"
        />
      </div>
      <div class="detailsLabel" v-if="formSource.mp4.length > 0">视频：</div>
      <div class="source_item" v-if="formSource.mp4.length > 0">
        <video
          v-for="(item, index) in formSource.mp4"
          :key="index"
          style="width: 50%"
          :src="fileIdSrc(item)"
          controls="controls"
        ></video>
      </div>
      <div class="detailsLabel" v-if="formSource.mp3.length > 0">音频：</div>
      <div class="source_item" v-if="formSource.mp3.length > 0">
        <audio
          v-for="(item, index) in formSource.mp3"
          :key="index"
          style="width: 50%"
          :src="fileIdSrc(item)"
          controls="controls"
        ></audio>
      </div>
    </div>
    <h-big-picture
      :pictureUrl="pictureUrl"
      v-model:visible="bigPictureVisible"
    ></h-big-picture>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, watchEffect } from "vue";
import _ from "lodash";
export default defineComponent({
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const state = reactive({
      imgURL: window.imgURL,
      columns: [
        {
          label: "事件名称",
          prop: "eventName",
        },
        {
          label: "事件类型",
          prop: "eventTypeDict",
        },
        // {
        //   label: "事发地点",
        //   prop: "eventAddress",
        // },
        // {
        //   label: "开始时间",
        //   prop: "startTime",
        // },
        // {
        //   label: "结束时间",
        //   prop: "endTime",
        // },

        {
          label: "上报人",
          prop: "reporter",
        },
        {
          label: "上报时间",
          prop: "reportTime",
        },
        {
          label: "联系电话",
          prop: "reporterPhone",
        },
        {
          label: "状态",
          prop: "state",
        },
        {
          label: "事件描述",
          prop: "description",
        },
        // {
        //   label: '分派人',
        //   prop: ""
        // },
        // {
        //   label: '分派时间',
        //   prop: ""
        // },
        // {
        //   label: '分派历史',
        //   prop: ""
        // }
      ],
      bigPictureVisible: false,
      pictureUrl: null,
      formSource: null,
    });
    watchEffect(() => {
      console.log(props.form);
      const params = _.cloneDeep(props.form);
      (params.img = []),
        (params.mp4 = []),
        (params.mp3 = []),
        params.fileUrls &&
          params.fileUrls.forEach((element) => {
            const type = element.split(".");
            if (type[1] == "png" || type[1] == "jpg") {
              params.img.push(element);
            } else if (type[1] == "mp4") {
              params.mp4.push(element);
            } else if (type[1] == "mp3") {
              params.mp3.push(element);
            }
          });
      state.formSource = params;
      console.log(state.formSource);
    });
    const stateData = (is) => {
      let str = "";
      switch (is) {
        case "1":
          str = "未分配";
          break;
        case "2":
          str = "处理中";
          break;
        case "3":
          str = "再上报（处理中）";
          break;
        case "4":
          str = "忽略";
          break;
        case "5":
          str = "已解决";
          break;
        default:
          break;
      }
      return str;
    };
    const eventTypeData = (is) => {
      let str = "";
      switch (is) {
        case "1":
          str = "打架斗殴";
          break;
        case "2":
          str = "非法游行";
          break;
        case "3":
          str = "噪音扰民";
          break;
        case "4":
          str = "领里纠纷";
          break;
        default:
          break;
      }
      return str;
    };
    const fileIdSrc = (val) => {
      return val ? state.imgURL + val : "@/assets/images/moren.png";
    };

    // 图片点击
    const clickImg = (picUrl) => {
      state.pictureUrl = state.imgURL + picUrl;
      state.bigPictureVisible = true;
    };
    return {
      ...toRefs(state),
      stateData,
      eventTypeData,
      clickImg,
      fileIdSrc,
    };
  },
});
</script>
<style lang="scss" scoped>
.sqDetail {
  width: 100%;
  max-height: 50vh;
  margin: 40px auto;
  display: flex;
  flex-wrap: wrap;
  padding: 0 5%;
  overflow: auto;
  .imginfo {
    width: 100%;
    .source_item {
      width: 100%;
      min-height: 150px;
      @include flex-col-c-c;
    }
    img {
      width: 150px;
      height: 100px;
      margin: 15px 0;
    }
    video {
      width: 250px;
      height: 150px;
      margin: 15px 0;
    }
    audio {
      margin: 15px 0;
    }
  }
  .details {
    height: 50px;
    width: 50%;

    span:nth-child(1) {
      display: inline-block;
      width: 80px;
    }
    span:nth-child(2) {
      margin-left: 10px;
    }
  }
  .detailsLabel {
    font-size: 16px;
    font-weight: 700;
  }
}
</style>
